export { };

Date.prototype.toString = Date.prototype.toISOString; // eslint-disable-line no-extend-native